import { useAuth } from '../../shared/context';
import { DiligenceRequestsPage } from './DiligenceRequestsPage';
import { LenderDiligenceRequestsPage } from './LenderDiligenceRequestsPage';

export const DiligenceRequests: React.FC = () => {
	var { currentUser, isTeamMember } = useAuth();

	return currentUser.isBankUser ? (
		<LenderDiligenceRequestsPage currentUser={currentUser} isTeamMember={isTeamMember} />
	) : (
		<DiligenceRequestsPage currentUser={currentUser} />
	);
};
